module.exports = __webpack_public_path__ + "img/dead.1dde0a48.gif";